import React, { Component } from 'react'

import Timeout from 'mixins/Timeout'

export default WrappElement => (
    @Timeout
    class LayoutWindowMixin extends Component {
        constructor( props ) {
            super( props )

            this.state = {
                width: parseFloat( window.innerWidth ),
                height: parseFloat( window.innerHeight ),
                orientation: 'portrait',
                scrollTop: 0
            }
        }

        handleUpdateView__Layout() {
            const width  = parseFloat( window.innerWidth )
            const height = parseFloat( window.innerHeight )

            let orientation = 'portrait'

            if( height < width )
            {
                orientation = 'landscape'
            }

            const scrollTop = window.pageYOffset

            if(
                this.state.width !== width &&
                this.state.height !== height &&
                this.state.orientation !== orientation &&
                this.state.scrollTop !== scrollTop
            )
            {
                this.setState({ width, height, orientation })
            } else {
                if( this.state.width !== width ) this.setState({ width })
                if( this.state.height !== height ) this.setState({ height })
                if( this.state.orientation !== orientation ) this.setState({ orientation })
                if( this.state.scrollTop !== scrollTop ) this.setState({ scrollTop })
            }

            this.props.setTimeout( this.handleUpdateView__Layout.bind(this), 500 )
        }

        componentDidMount() {
            this.handleUpdateView__Layout()
        }

        componentDidUpdate() {
            this.handleUpdateView__Layout()
        }

        render() {
            return (
                <WrappElement { ...this.props } { ...this.state } />
            )
        }
    }
)